import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AuthService } from '../../service/auth-service/auth.service';
import { Observable } from 'rxjs';
import { sweetAlert } from '../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { Router } from '@angular/router';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  getState: Observable<any>;
  constructor(private fb: UntypedFormBuilder, private authService: AuthService,private router: Router) {
  }
  forgotPasswordForm: UntypedFormGroup;
  submitted = false;
   isCompany = true;       // Default is Company


  ngOnInit() {

    // this.getState
    // .pipe(takeUntil(takeUntilDestroyed(this)))
    // .subscribe((state) => {
    //   const errorMessage = state.errorMessage;
    //   if (state.type === AuthActionTypes.FORGET_PASSWORD && errorMessage != null) {
    //     if (state.success) {
    //       sweetAlert('Success', errorMessage, 'success', 'OK');
    //     } else {
    //       sweetAlert('Error', errorMessage, 'error', 'OK');
    //     }
    //   }
    // });

    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
  get form() {
    return this.forgotPasswordForm.controls;
  }

  onForgotPassword() {

    this.submitted = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    } else {
      const payload = {
        email: this.forgotPasswordForm.value.email,
        roles: this.role   // <-- dynamic role from toggle
      };
      this.authService
        .forgetPasswordRequestwithNgx(payload)
        .pipe(takeUntil(takeUntilDestroyed(this)))
        .subscribe(data => {
          if (data && data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message || 'Something went wrong', 'error', 'OK');
          }
          this.forgotPasswordForm.reset();
           this.submitted = false;
        })
    }
  }

   backToLogin() {
    this.router.navigateByUrl('/login')
  }

  get role(): 'company' | 'staff' {
    return this.isCompany ? 'company' : 'staff';
  }

  ngOnDestroy(): void {
  }
}
